import { GetLeadSource } from "@/dtos/LeadSource.dto";
import { StateObject } from "@/dtos/State.dto";
import LeadSource from "@/services/lead-source";
import { CLEAR_LEAD_SOURCE_ISLOADING, GET_LEAD_SOURCES } from "@/store/action-types";
import { SET_ERRORMSG, SET_LEAD_SOURCE, SET_LEAD_SOURCES } from "@/store/mutation-types";
import { AxiosResponse } from "axios";
import { Module } from "vuex";

const leadSource: Module<any, {}> = {
  state: {
    leadSource: {
      data: null,
      isLoading: false,
    },
    leadSources: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    leadSource: (state: { leadSource: any }) => state.leadSource,
    leadSources: (state: { leadSources: any }) => state.leadSources,
  },
  mutations: {
    [SET_LEAD_SOURCE]: (
      state: { leadSource: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.leadSource.data = payload.data;
      state.leadSource.isLoading = payload.isLoading;
    },
    [SET_LEAD_SOURCES]: (
      state: { leadSources: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      if (payload.data != null) state.leadSources.data = payload.data;
      state.leadSources.isLoading = payload.isLoading;
    },
  },
  actions: {
    [GET_LEAD_SOURCES]: async ({ commit }: any, payload: any) => {
      commit(SET_LEAD_SOURCES, { data: null, isLoading: true });

      try {
        const result: AxiosResponse = await LeadSource.getLeadSources(payload as GetLeadSource);

        if (result) {
          if (result.data.status) {
            commit(SET_LEAD_SOURCES, {
              data: result.data.data,
              isLoading: false,
            });
            return true;
          }
          commit(SET_LEAD_SOURCES, { data: null, isLoading: false });
          commit(SET_ERRORMSG, result.data.msg);
          return false;
        } else {
          commit(SET_LEAD_SOURCES, { isLoading: false });
          return false;
        }
      } catch (error: any) {
        commit(SET_LEAD_SOURCES, { data: null, isLoading: false });

        if (error.code === "ECONNABORTED" || error.message?.includes("timeout")) {
          commit(SET_ERRORMSG, "Request timed out. Please check your connection and try again.");
        } else {
          commit(SET_ERRORMSG, error.response?.data?.message || "Failed to load lead sources");
        }
        return false;
      }
    },
    [CLEAR_LEAD_SOURCE_ISLOADING]: ({ commit }) => {
      commit(SET_LEAD_SOURCE, { isLoading: false });
      commit(SET_LEAD_SOURCES, { isLoading: false });
    },
  },
};

export default leadSource;
